import { API_URL } from '~/constants/environment'

import { Api } from '../../utils/api'
import type { ProductVariant } from '../@types'

const api = new Api(API_URL, 'customers/product_variants')

export const fetchProductVariant = async (id: ProductVariant['id']) => {
  return (
    await api.get<{ data: ProductVariant }>({
      path: id,
    })
  ).data
}
